import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import store from "@beeldit/core/services/store";
import { CreateActionContext } from "./CreateActionContext";

function useStore() {
  const { element, setBackendFormErrors, setAdjustmentError, setElement } = useContext(CreateActionContext);
  const errorHandler = useErrorHandler();
  return (onSuccess: any, dataOverride?: any) => {
    const dataToSend = dataOverride || element;
    // Si hay override, actualizar el contexto primero
    if (dataOverride) {
      setElement(dataOverride);
    }
    
    store("combinations", dataToSend)
      .then((response: any) => {
        setBackendFormErrors({});
        setAdjustmentError(null);
        onSuccess(response.data);
      })
      .catch((error: any) => {
        // Interceptar errores de ajuste de PVP antes del error handler estándar
        if (error.response?.status === 422 && error.response?.data?.errors) {
          const errors = error.response.data.errors;
          if (errors.new_price || errors.new_commission_percentage) {
            setAdjustmentError({
              new_price: errors.new_price?.[0],
              new_commission_percentage: errors.new_commission_percentage?.[0]
            });
            return;
          }
        }
        errorHandler(error, setBackendFormErrors);
      });
  };
}

export default useStore;
